// Сурагчийн нүүр — самбар: мэндчилгээ + хаус, дээд талд Миний QR (ирц бүртгүүлэх,
// танхим захиалгад уншуулна), ирц (7 хоног / сараар), ирэх захиалгууд.
// Танхим захиалах нь доод цэсэнд байгаа тул нүүрэнд товч давхардуулахгүй.
import React, { useEffect, useState, useContext, useMemo } from "react";
import { instance } from "utils/axios";
import { Modal, Tag, Spin, Empty, Segmented } from "antd";
import QRCode from "qrcode.react";
import { AuthContext } from "contexts";
import AttendanceDays, { StatusChips } from "./AttendanceDays";
import { Link, useNavigate } from "react-router-dom";
import { FiMaximize2, FiChevronRight, FiChevronLeft, FiRefreshCw } from "react-icons/fi";
import dayjs from "dayjs";
import { LearningOverview } from "pages/Study";
import { HouseMark } from "components/brand";
import MyPrograms from "pages/Passion/MyPrograms";
import SurveyCards from "pages/Survey/Cards";

const BOOK_STATUS = {
  pending: { color: "gold", label: "Хүлээгдэж буй" },
  approved: { color: "green", label: "Зөвшөөрсөн" },
  rejected: { color: "red", label: "Татгалзсан" },
  cancelled: { color: "default", label: "Цуцалсан" },
};
const DOW = ["Ня", "Да", "Мя", "Лх", "Пү", "Ба", "Бя"];

function StudentDay() {
  const navigate = useNavigate();
  const { state } = useContext(AuthContext);
  const student = state.studentInfo?.profile;
  const [attendance, setAttendance] = useState([]);
  const [profile, setProfile] = useState({});
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(false);
  const [period, setPeriod] = useState("week"); // week | month
  const [cursor, setCursor] = useState(dayjs()); // харж буй 7 хоног/сарын дурын өдөр
  const [qrBig, setQrBig] = useState(false);

  // Харах хугацаа: 7 хоног (Да–Ба) эсвэл сар
  const from = period === "week" ? cursor.startOf("week").add(1, "day") : cursor.startOf("month");
  const to = period === "week" ? cursor.startOf("week").add(5, "day") : cursor.endOf("month");

  const fetchData = () => {
    setLoading(true);
    Promise.all([
      instance({ method: "get", url: `/student/attendance?date1=${from.format("YYYY-MM-DD")}&date2=${to.format("YYYY-MM-DD")}` })
        .then((r) => setAttendance(r.data || [])),
      instance({ method: "get", url: "/student/profile" }).then((r) => setProfile(r.data || {})),
      instance({ method: "get", url: "/student/booking/my" }).then((r) => setBookings(r.data || [])),
    ])
      .catch(() => {})
      .then(() => setLoading(false));
  };
  useEffect(fetchData, [period, cursor.valueOf()]); // eslint-disable-line react-hooks/exhaustive-deps

  // ── QR уншигч ──
  // ── Ирц: өдөр бүрд нэг төлөв; 7 хоног = 1 мөр, сар = долоо хоног бүр мөр (Да–Ба) ──
  const cal = useMemo(() => {
    const byDay = {};
    attendance.forEach((a) => {
      byDay[dayjs(a.attendanceDate || a.attendanceTime).format("YYYY-MM-DD")] = a.status;
    });
    const rows = [];
    let wk = from.startOf("week").add(1, "day"); // Даваа
    const last = to;
    while (wk.isBefore(last) || wk.isSame(last, "day")) {
      const days = [];
      for (let i = 0; i < 5; i++) {
        const d = wk.add(i, "day");
        const inRange = !d.isBefore(from, "day") && !d.isAfter(to, "day");
        days.push({ key: d.format("YYYY-MM-DD"), dow: DOW[d.day()], dd: d.format("DD"), status: byDay[d.format("YYYY-MM-DD")], today: d.isSame(dayjs(), "day"), inRange, future: d.isAfter(dayjs(), "day") });
      }
      rows.push(days);
      wk = wk.add(7, "day");
    }
    const stat = {};
    attendance.forEach((a) => { stat[a.status] = (stat[a.status] || 0) + 1; });
    return { rows, stat };
  }, [attendance, from.valueOf(), to.valueOf()]); // eslint-disable-line react-hooks/exhaustive-deps

  const shift = (n) => setCursor((c) => c.add(n, period === "week" ? "week" : "month"));
  const rangeLabel = period === "week"
    ? `${from.format("MM.DD")} – ${to.format("MM.DD")}`
    : `${cursor.format("YYYY")} оны ${cursor.month() + 1}-р сар`;

  // QR-ийн код: серверээс татсан профайлыг эрхэмлэнэ (кэшлэгдсэн хуучин код QR-т орохоос сэргийлнэ)
  const qrCode = String(profile?.code || student?.code || "");
  const upcoming = bookings.filter((b) => ["pending", "approved"].includes(b.status) && b.bookingDate >= dayjs().format("YYYY-MM-DD")).slice(0, 3);
  const firstName = student?.firstName || "";
  const hour = dayjs().hour();
  const greet = hour < 12 ? "Өглөөний мэнд" : hour < 18 ? "Өдрийн мэнд" : "Оройн мэнд";

  return (
    <div className="pt-4 md:pt-6 flex flex-col gap-4">
      {/* Мэндчилгээ + хаус */}
      <section className="pcard pcard-pad flex items-center gap-4 bg-gradient-to-br from-primary to-[#8b2fd1] !border-0 text-white">
        {/* Өөрийн зураг; хаус — буланд тэмдэг (зураггүй бол хаусын лого) */}
        <div className="relative shrink-0">
          <div className="h-16 w-16 rounded-2xl bg-primary flex items-center justify-center overflow-hidden ring-1 ring-white/25">
            {profile?.imageUrl ? (
              <img src={profile.imageUrl} alt={firstName} referrerPolicy="no-referrer" className="h-full w-full object-cover" />
            ) : profile?.house?.googleLink ? (
              <img src={profile.house.googleLink} alt={profile.house.name || "house"} referrerPolicy="no-referrer" className="h-full w-full object-contain p-1.5" />
            ) : <span className="text-2xl font-bold">{firstName.charAt(0)}</span>}
          </div>
          {profile?.imageUrl && profile?.houseId && <HouseMark house={profile.houseId} size={26} className="absolute -right-2 -bottom-2 ring-2 ring-white/70" />}
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-white/70 text-xs">{greet}</div>
          <div className="text-xl font-bold truncate">{firstName} 👋</div>
          <div className="text-white/80 text-xs mt-0.5">
            {qrCode} · {student?.grade ? `${student.grade}-р анги` : ""}{profile?.house?.name ? ` · ${profile.house.name}` : ""}
          </div>
        </div>
        {profile?.house && (
          <div className="text-right shrink-0">
            <div className="text-2xl font-bold leading-none">{Intl.NumberFormat().format(profile.house.point || 0)}</div>
            <div className="text-white/70 text-[11px]">house point · {profile.house.place ? `${profile.house.place}-р байр` : ""}</div>
          </div>
        )}
      </section>

      {/* Асуулга · Мэдэгдэл · Миний сурлагын явц · Миний хуваарь */}
      <SurveyCards />
      <StudentNotices />
      <MyPrograms />
      <section className="flex flex-col gap-2">
        <h2 className="font-bold text-gray-900 m-0">Миний сурлагын явц</h2>
        <LearningOverview who="me" compact />
      </section>
      <Link to="/schedule" className="pcard pcard-pad flex items-center gap-3 !text-gray-900">
        <span className="flex-1"><span className="block font-bold">Миний хуваарь</span><span className="block text-xs text-gray-500">7 хоногийн хичээлийн хуваарь</span></span>
        <FiChevronRight className="text-primary" />
      </Link>
      {/* Тусгал — цэснээс энд шилжсэн (хичээлийн ирцэд тооцогдоно) */}
      <Link to="/reflections" className="pcard pcard-pad flex items-center gap-3 !text-gray-900">
        <span className="flex-1"><span className="block font-bold">Тусгал</span><span className="block text-xs text-gray-500">Хичээл бүрийн дараа бичнэ · ирцэд тооцогдоно</span></span>
        <FiChevronRight className="text-primary" />
      </Link>

      {/* Миний QR — хамгийн дээр, дарвал бүтэн дэлгэцээр (ирц, танхим захиалгад уншуулна) */}
      <section className="pcard pcard-pad flex flex-col items-center">
        <button onClick={() => setQrBig(true)} className="p-3 bg-white rounded-2xl border border-gray-100 active:scale-[0.99] transition-transform">
          <QRCode value={qrCode} size={176} level="H" />
        </button>
        <div className="mt-2 text-xl font-bold tracking-wide">{qrCode}</div>
        <button onClick={() => setQrBig(true)} className="mt-1 text-xs text-primary font-medium flex items-center gap-1">
          <FiMaximize2 size={13} /> Томруулж харуулах
        </button>
      </section>

      <div className="grid grid-cols-1 gap-4">
        {/* Ирц */}
        <section className="pcard pcard-pad">
          <div className="flex items-center justify-between mb-3 gap-2 flex-wrap">
            <div>
              <h2 className="font-bold text-gray-900">Ирц</h2>
              <div className="psub">{rangeLabel}</div>
            </div>
            <div className="flex items-center gap-1">
              <Segmented size="small" value={period} onChange={(v) => { setPeriod(v); setCursor(dayjs()); }}
                options={[{ value: "week", label: "7 хоног" }, { value: "month", label: "Сар" }]} />
              <button onClick={() => shift(-1)} className="h-8 w-8 rounded-lg hover:bg-gray-100 text-gray-500 flex items-center justify-center"><FiChevronLeft /></button>
              <button onClick={() => shift(1)} className="h-8 w-8 rounded-lg hover:bg-gray-100 text-gray-500 flex items-center justify-center"><FiChevronRight /></button>
              <button onClick={fetchData} className="h-8 w-8 rounded-lg hover:bg-gray-100 text-gray-400 flex items-center justify-center"><FiRefreshCw size={15} className={loading ? "animate-spin" : ""} /></button>
            </div>
          </div>
          {loading && !attendance.length ? (
            <div className="flex justify-center py-6"><Spin /></div>
          ) : (
            <>
              <div className="mb-2"><StatusChips counts={cal.stat} /></div>
              <AttendanceDays
                days={attendance.map((a) => ({
                  date: dayjs(a.attendanceDate || a.attendanceTime).format("YYYY-MM-DD"),
                  status: a.status,
                  time: a.attendanceTime,
                }))}
                limit={period === "week" ? 7 : 10}
              />
            </>
          )}
        </section>

      </div>

      {/* Ирэх захиалгууд */}
      <section className="pcard pcard-pad">
        <div className="flex items-center justify-between mb-2">
          <h2 className="font-bold text-gray-900">Танхимын захиалга</h2>
          <button onClick={() => navigate("/booking")} className="text-sm text-primary font-medium flex items-center gap-1">Бүгд <FiChevronRight /></button>
        </div>
        {upcoming.length ? (
          <div className="flex flex-col divide-y divide-gray-50">
            {upcoming.map((b) => (
              <div key={b.id} className="py-2.5 flex items-center gap-3">
                <div className="h-10 w-10 rounded-xl bg-gray-50 flex flex-col items-center justify-center shrink-0">
                  <span className="text-[10px] text-gray-400 leading-none">{dayjs(b.bookingDate).format("MM")}</span>
                  <span className="font-bold leading-tight">{dayjs(b.bookingDate).format("DD")}</span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-semibold text-sm truncate">{b.facility?.name} <span className="text-gray-400 font-normal">· {b.startTime}–{b.endTime}</span></div>
                  <div className="text-xs text-gray-400 truncate">{b.headCount} хүн · {b.purpose}</div>
                </div>
                <Tag color={BOOK_STATUS[b.status]?.color} className="!mr-0">{BOOK_STATUS[b.status]?.label}</Tag>
              </div>
            ))}
          </div>
        ) : (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={<span className="text-gray-400 text-sm">Ирэх захиалга байхгүй — хичээлийн дараа сул анги захиалж болно</span>} />
        )}
      </section>

      {/* QR томруулах */}
      <Modal open={qrBig} onCancel={() => setQrBig(false)} footer={null} centered width={360}>
        <div className="flex flex-col items-center py-4">
          <QRCode value={qrCode} size={260} level="H" />
          <div className="mt-4 text-xl font-bold">{qrCode}</div>
          <div className="text-gray-400 text-sm">{student?.lastName} {student?.firstName}</div>
        </div>
      </Modal>

    </div>
  );
}

export default StudentDay;

// Сүүлийн мэдэгдлүүд (уншаагүй нь тодоор) — бүгдийг дээд талын хонхноос
function StudentNotices() {
  const [list, setList] = useState(null);
  useEffect(() => {
    instance({ method: "get", url: "/notifications", params: { limit: 3 }, silent: true })
      .then((r) => setList(r.data?.rows || r.data?.items || (Array.isArray(r.data) ? r.data : [])))
      .catch(() => setList([]));
  }, []);
  if (!list || !list.length) return null;
  return (
    <section className="pcard pcard-pad flex flex-col gap-2">
      <h2 className="font-bold text-gray-900 m-0">Мэдэгдэл</h2>
      {list.slice(0, 3).map((n) => (
        <div key={n.id} className={`text-sm ${n.readAt || n.isRead ? "text-gray-500" : "text-gray-900 font-semibold"}`}>
          {n.title || n.body}
          {n.title && n.body ? <span className="block text-xs font-normal text-gray-500 truncate">{n.body}</span> : null}
        </div>
      ))}
    </section>
  );
}
